import { IIrpPageRequest } from '../../../../model/scp/irp/request/irp-paged-request';
import { ITableResponse } from '../../../../model/scp/purchase/response/tables-response';

export type IrpSearchState = {
  modality: ITableResponse[];
  parameters: IIrpPageRequest;
  searchTrigger: number;
};

export enum ACTION_TYPES {
  setModality = 'setModality',
  setParameters = 'setParameters',
  updateParameter = 'updateParameter',
  triggerSearch = 'triggerSearch',
}

export const IrpSearchReducer = (state: IrpSearchState, action: any): IrpSearchState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setModality:
      return {
        ...state,
        modality: payload,
      };
    case ACTION_TYPES.setParameters:
      return {
        ...state,
        parameters: payload,
      };
    case ACTION_TYPES.updateParameter:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...payload,
        },
      };
    case ACTION_TYPES.triggerSearch:
      return {
        ...state,
        searchTrigger: state.searchTrigger + 1,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
